module.exports = __webpack_public_path__ + "static/payment-pattern-d04d510765c9c37847e7c734ed193a68.png";